import React from 'react'
import { string, object } from 'prop-types'

class ProductSelect extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (e) {
    let { parentElement } = e.target
    if (e.target.tagName === 'SPAN') {
      parentElement = parentElement.parentElement
    }
    if (parentElement.className.indexOf('open') > -1) {
      parentElement.className = parentElement.className.replace(' open', '')
    } else {
      parentElement.className += ' open'
    }
    e.preventDefault()
  }

  render () {
    const { id, options, label } = this.props
    const dropdownLinks = Object.keys(options).map(page => {
      const title = options[ page ]
      return (<li key={page}><a href={'/' + page + '.html'} title={title}>{ title }</a></li>)
    })

    return (
      <div id={id} className='btn-group'>
        <button type='button' onClick={this.handleClick} className='btn btn-default dropdown-toggle' data-toggle='dropdown'>{ label }: <span className='caret' />
        </button>
        <ul className='dropdown-menu' role='menu'>
          { dropdownLinks }
        </ul>
      </div>
    )
  }
}

ProductSelect.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  options: object.isRequired
}

export default ProductSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/productSelect.jsx